<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>

            </v-row>
            <!--<v-container>
                <v-row>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Year -->
                        <!--<v-menu v-model="yearMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                              :label="$t('Year')"
                                              readonly
                                              v-bind="attrs" @input="selectYear($event)"
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker :max="maxDate"
                                           type="year" @click:year="selectYear($event)"></v-date-picker>
                        </v-menu>

                    </v-col>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Quarter (using Calendar) -->
                        <!--<v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                                  :items="quarters"
                                  :label="$t('Quarter')"></v-select>
                    </v-col>
                </v-row>
            </v-container>-->
            <!-- Shared Color Pickers -->

            <v-dialog v-model="dialog" persistent max-width="100vw">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row v-if="!istriple">
                            <v-col cols="12" md="2" v-for="(color, index) in sharedColors" :key="'color-picker-' + index">
                                <v-color-picker v-model="sharedColors[index]"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                        <v-row v-if="istriple && !isintishar">
                            <v-col cols="12" md="2" v-for="(color, index) in triplesharedColors" :key="'color-picker-' + index">
                                <v-color-picker v-model="triplesharedColors[index]"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                        <v-row v-if="istriple && isintishar">
                            <v-col cols="12" md="2" v-for="(color, index) in tripleIntisharsharedColors" :key="'color-picker-' + index">
                                <v-color-picker v-model="tripleIntisharsharedColors[index]"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-text>

        <!-- Chart One -->
        <v-card-text class="align-center text-center" style="font-size: 21px;">
            <template>
                <v-container>
                    <v-row v-for="(item, rowIndex) in value" :key="'row-' + rowIndex" class="align-center">
                        <v-col cols="7" class="text-right" style="color: #000;padding:0px">
                            {{ item.name }}
                        </v-col>
                        <v-col cols="4" style="padding:0px">
                            <v-row dense v-if="!isintishar">
                                <v-col v-for="(percentage, idx) in item.table"
                                       :key="'cell-' + rowIndex + '-' + idx"
                                       :style="{ backgroundColor: istriple?triplesharedColors[idx]:sharedColors[idx] }"
                                       class="text-center white--text">
                                    {{ percentage.percentage }}%
                                </v-col>
                            </v-row>
                            <v-row dense v-else>
                                <v-col v-for="(percentage, idx) in item.table"
                                       :key="'cell-' + rowIndex + '-' + idx"
                                       :style="{ backgroundColor: tripleIntisharsharedColors[idx] }"
                                       class="pa-2 text-center white--text">
                                    {{ percentage.percentage }}%
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="1" class="text-center" style="padding:10px">
                            <v-progress-circular :value="item.percentage" size="40" width="6" :color="isintishar?'#CA4A56':'teal'">
                                <span style="font-size:13px">{{ item.percentage }}%</span>
                            </v-progress-circular>
                        </v-col>
                    </v-row>

                    <v-row class="mt-5 align-end" style="margin-right: 50%;">
                        <v-col cols="12">
                            <div v-if="!istriple" class="text-center">
                                <v-chip v-for="(label, idx) in legend"
                                        :key="idx"
                                        class="ma-1 white--text"
                                        :color="sharedColors[idx]">
                                    {{ label.text }}
                                </v-chip>

                            </div>

                            <div v-if="istriple" class="text-center">
                                <div v-if="isintishar" class="text-center">
                                    <v-chip v-for="(label, idx) in tripleIntisharlegend"
                                            :key="idx"
                                            class="ma-1 white--text"
                                            :color="tripleIntisharsharedColors[idx]">
                                        {{ label.text }}
                                    </v-chip>
                                </div>
                                <div v-else class="text-center">
                                    <v-chip v-for="(label, idx) in triplelegend"
                                            :key="idx"
                                            class="ma-1 white--text"
                                            :color="triplesharedColors[idx]">
                                        {{ label.text }}
                                    </v-chip>
                                </div>
                            </div>
</v-col>
                    </v-row>
                </v-container>
            </template>
        </v-card-text>

    </v-card>
</template>
<script>
    import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'

    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            istriple: {
                type: Boolean,
                default: () => false
            },
            isintishar: {
                type: Boolean,
                default: () => false
            },
            quarters: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                selectedChart: 'chart1', // Default to horizontal view
                sharedColors: ['#14573a', '#1b8354', '#fec84b', '#f04438', '#b42318'], // Default shared colors
                legend: [

                    { text: this.$t('VerySatisfied'), color: '#14573a' },
                    { text: this.$t('Satisfied'), color: '#1b8354' },
                    { text: this.$t('Neutral'), color: '#fec84b' },
                    { text: this.$t('Dissatisfied'), color: '#f04438' },
                    { text: this.$t('VeryDissatisfied'), color: '#b42318' },
                ],
                triplesharedColors: ['#6AA685', '#91BDA4', '#E6D3A2'], // Default shared colors
                tripleIntisharsharedColors: ['#CA4A56', '#D77780', '#E6D3A2'], // Default shared colors
                triplelegend: [

                    { text: this.$t('VerySatisfied'), color: '#2d6813' },
                    { text: this.$t('Satisfied'), color: '#14573A' },
                    { text: this.$t('Neutral'), color: '#ffc107' },
                ],
                tripleIntisharlegend: [

                    { text: this.$t('WidelySpread'), color: '#CA4A56' },
                    { text: this.$t('FairlyWidespread'), color: '#D77780' },
                    { text: this.$t('NotWideSpread'), color: '#E6D3A2' },
                ],
                dialog: false,
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],
            }
        },
        watch: {
            sharedColors: {
                handler(newColors) {
                    // Update all row colors dynamically
                    this.value.forEach((row) => {
                        row.table.forEach((item, index) => {
                            item.color = newColors[index]
                        })
                    })
                },
                deep: true,
            },
        },
        mounted() {
            Chart.register(ArcElement, Tooltip, Legend)
        },
        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectSatisfactionPerQuestionYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectSatisfactionPerQuestionQuarter', quarter)
            }
        }
    }
</script>
<style scoped>

    
    .pa-2 {
        padding: 10px;
    }

    .text-right {
        text-align: right;
    }

    .text-center {
        text-align: center;
    }
</style>
